module.exports = __webpack_public_path__ + "images/40cee69d.pay_2_usa.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipintro/pay_2_usa.png
// module id = 519
// module chunks = 0